@use '@lib/assets/styles/main.scss' as *;

.counterHeader {
  padding-top: 0;
  padding-bottom: 16px;
}

.headerActions {
  display: flex;
  gap: 16px;
}

.viewChangeActions {
  display: flex;
  gap: 8px;
}
